import React from "react";
import AuthorImg1 from "../../../assets/images/AuthorNetworkingImg.svg";
import AuthorImg2 from "../../../assets/images/AuthorNetworkingImg.svg";
import AuthorImg3 from "../../../assets/images/AuthorNetworkingImg.svg";
import styles from "./AuthorMembersFeatures.module.css";
import { useNavigate } from "react-router-dom";

const OutcomeData = [
  {
    img: AuthorImg1,
    title: "Networking",
    desc: "Connect with fellow researchers globally",
  },
  {
    img: AuthorImg2,
    title: "Resources",
    desc: "Access exclusive research tools",
  },
  {
    img: AuthorImg3,
    title: "Recognition",
    desc: "Showcase your achievements",
  },
];

export default function AuthorMembersFeatures() {
   const navigate = useNavigate();
  
  return (
    <section className={styles.outcomes}>
      <div className={styles.container}>
        <div className={styles.topContainer}>
          <div className={styles.heading}>
            <h3>
              Research  <span>Associates </span>
            </h3>
            <h5>Discover published authors and their research contributions</h5>
          </div>
          <div className={styles.viewAll}>
            <button onClick={() => navigate("/authors")}>View All Profiles</button>
          </div>
        </div>
        <div className={styles.cards}>
          {OutcomeData.map((i) => (
            <article className={styles.card}>
              <figure>
                <img src={i.img} alt={i.title} />
              </figure>
              <div className={styles.content}>
                <h4>{i.title}</h4>
                <p>{i.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
